module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"react","commonjs":"react","commonjs2":"react","root":"React"}
// module id = 0
// module chunks = 0